import KeyValue from "./keyValue";
import JobNote from "./jobNote";
import JobAssignee from "./jobAssignee";
import JobTime from "./jobTime";
import JobEquipment from "./jobEquipment";
import Site from "./site";
import JobVendor from "./jobVendor";
import JobMilestone from "./jobMilestone";
import JobStatus from "./jobStatus";
import Category from "./category";
import Answer from "./answerVM";
import JobType from "./jobType";

export default interface Job {
  id: number;
  jobSource?: KeyValue;
  communicationMethod?: KeyValue;
  jobType?: JobType;
  jobStatus?: JobStatus;
  site?: Site;
  serviceTicketNumber?: string;
  jobNumber: string;
  title?: string;
  owner?: string;
  parentJob?: KeyValue;
  jobAction?: KeyValue;
  jobCategory?: Category;
  description: string;
  solution?: string;
  highPriority: boolean;
  jobAssignees: JobAssignee[];
  jobEquipments: JobEquipment[];
  jobMilestones: JobMilestone[];
  jobVendors: JobVendor[];
  jobNotes: JobNote[];
  jobTimes: JobTime[];
  attachments: KeyValue[];
  dateReceived?: Date;
  highlightDate?: Date;
  answers: Answer[];
  closedDate?: Date;
  completedOn?: Date;
  completedBy?: KeyValue;
  createdOn?: Date;
  createdById?: number;
  modifiedOn?: Date;
  modifiedById?: number;
}

export const initialJob: Job = {
  id: 0,
  jobType: undefined,
  jobStatus: undefined,
  site: undefined,
  jobCategory: undefined,
  highPriority: false,
  serviceTicketNumber: "",
  jobNumber: "",
  title: "",
  description: "",
  solution: "",
  dateReceived: new Date(),
  jobAssignees: [],
  answers: [],
  jobEquipments: [],
  jobMilestones: [],
  jobVendors: [],
  jobNotes: [],
  jobTimes: [],
  attachments: [],
};
